import React from "react";
import cuid from "cuid";
import { Line } from "rc-progress";

import "./index.scss";

const renderRow = (call, theme) => {
  let trailColor;

  if (theme === "light") {
    trailColor = "#DBDBDB";
  }

  if (theme === "dark") {
    trailColor = "#2D4961";
  }

  return (
    <tr key={call.id}>
      <td key={cuid()}>{call.id}</td>
      <td key={cuid()}>{call.title}</td>
      <td key={cuid()}>{call.service}</td>
      <td key={cuid()}>{call.place}</td>
      <td key={cuid()}>{call.lastUpdate}</td>
      <td key={cuid()}>
        <Line
          percent={call.progress}
          strokeWidth="4"
          strokeColor="#7dee89"
          trailColor={trailColor}
        />
        <div className="percent">{call.progress}%</div>
      </td>
    </tr>
  );
};

function index({ queue, theme, count }) {
  return (
    <div className={`card table-container ${theme}`}>
      <table>
        <thead>
          <tr>
            <th>Nº</th>
            <th>Título</th>
            <th>Serviço</th>
            <th>Local</th>
            <th>Última atualização</th>
            <th>Progresso</th>
          </tr>
        </thead>
        <tbody>
          {queue.map((call, i) => {
            if (i < count) {
              return renderRow(call, theme);
            }

            return null;
          })}
        </tbody>
      </table>
    </div>
  );
}

export default index;
